import { ref } from 'vue'
import { fetchAppConfig, type AppConfig } from '@/api/app-config'

const config = ref<AppConfig | null>(null)
let fetchPromise: Promise<void> | null = null

function load(): Promise<void> {
  if (fetchPromise === null) {
    fetchPromise = fetchAppConfig()
      .then((c) => {
        config.value = c
      })
      .catch(() => {
        fetchPromise = null
      })
  }

  return fetchPromise
}

/**
 * Forces a fresh fetch of the app config, bypassing the module-level cache.
 * Needed because the underlying Cache-Control TTL is now a few minutes rather
 * than a day, so a long-lived SPA session must be able to observe a runtime
 * toggle change (e.g. organiser sign-ups) without a full page reload.
 * Errors are swallowed exactly like the initial load — the previous config,
 * if any, is left untouched.
 */
async function refresh(): Promise<void> {
  fetchPromise = null
  await load()
}

export function useAppConfig(): { config: typeof config; refresh: typeof refresh } {
  void load()

  return { config, refresh }
}
